import './tailwind.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { PlatformProvider, FeatureProvider, createLocalLicenseAdapter, type Feature } from '@exiftrator/shared';
import { createWebPlatform } from '@exiftrator/platform-web';
import { shareButtonFeature } from '@exiftrator/platform-web/features';
import { WebRouter } from './WebRouter';

// Create web platform
const platform = createWebPlatform();
const appLicenseAdapter = createLocalLicenseAdapter(platform.storage, {
  allowBypass: Boolean(import.meta.env.DEV),
});
const demoLicenseAdapter = createLocalLicenseAdapter(platform.storage, {
  allowBypass: Boolean(import.meta.env.DEV),
  storageKeyPrefix: "exiftrator-demo-license",
  defaults: {
    gatingEnabled: true,
    proUnlocked: true,
    bypassEnabled: false,
  },
});

// Web-specific features
const webFeatures: Feature[] = [
  shareButtonFeature,
];

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <PlatformProvider platform={platform}>
      <FeatureProvider initialFeatures={webFeatures}>
        <WebRouter
          appLicenseAdapter={appLicenseAdapter}
          demoLicenseAdapter={demoLicenseAdapter}
        />
      </FeatureProvider>
    </PlatformProvider>
  </React.StrictMode>
);
